import { useState } from "react";

import { useCyclingOrder } from "../../components";
import { UiRotatingImagesModel } from "../../models";
import { renderViewModel, renderViewModels } from "../../render-view-model";

import { Container, RotatingItem } from "./UiRotatingImages.styles";

export type UiRotatingImagesProps = {
    model: UiRotatingImagesModel;
};

const UiRotatingImages = ({ model }: UiRotatingImagesProps) => {
    const [updatedAt, setUpdatedAt] = useState(0);
    /**
     * initialized with reverse order because stacked grid
     * displays last item on top
     */
    const items = useCyclingOrder(
        [...model.content.items].reverse(),
        updatedAt,
        true
    );
    const onAnimationEnd = () => {
        setUpdatedAt(Date.now());
    };
    const displayDuration = 5000;
    const transitionDuration = 500;

    if (items.length < 2) {
        return <>{renderViewModels(items)}</>;
    }

    return (
        <Container>
            {items.map((item, index) => (
                <RotatingItem
                    key={item.id}
                    hasAnimation={index === items.length - 1}
                    displayDuration={displayDuration}
                    transistionDuration={transitionDuration}
                    onAnimationEnd={onAnimationEnd}
                >
                    {renderViewModel(item)}
                </RotatingItem>
            ))}
        </Container>
    );
};

export default UiRotatingImages;
